"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataTable = exports.DataTableDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
exports.DataTableDefaultProps = {
  values: [],
  cellSpacing: 0
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    color: ", ";\n    width: 100%;\n  "], ["\n    font-size: ", ";\n    color: ", ";\n    width: 100%;\n  "])), theme_1.theme.FONT_SIZE(15), theme_1.theme.COLOR('text')),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 33.3333%;\n\n    ", "\n  "], ["\n    width: 33.3333%;\n\n    ", "\n  "])), function (props) {
    return props.isFullScreen && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      width: 100%;\n    "], ["\n      width: 100%;\n    "])));
  })
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: block;\n    box-sizing: border-box;\n    padding-right: ", ";\n  "], ["\n    display: block;\n    box-sizing: border-box;\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var RowStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    background-position: bottom left;\n    display: flex;\n    justify-content: space-between;\n\n    &:last-child {\n      background: none;\n    }\n  "], ["\n    ", ";\n    background-position: bottom left;\n    display: flex;\n    justify-content: space-between;\n\n    &:last-child {\n      background: none;\n    }\n  "])), theme_1.theme.DOT_BG('h', 'line-mid', 2, 4))
});
var HeaderCellStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    text-align: left;\n    font-weight: 500;\n    color: ", ";\n    padding: ", " 0;\n    display: block;\n    white-space: nowrap;\n  "], ["\n    text-align: left;\n    font-weight: 500;\n    color: ", ";\n    padding: ", " 0;\n    display: block;\n    white-space: nowrap;\n  "])), theme_1.theme.COLOR('dark'), theme_1.theme.UNIT(3))
});
var CellStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    color: ", ";\n    padding: ", " 0;\n    text-align: right;\n    display: block;\n\n  "], ["\n    color: ", ";\n    padding: ", " 0;\n    text-align: right;\n    display: block;\n\n  "])), theme_1.theme.COLOR('dark'), theme_1.theme.UNIT(3))
});
var HeadStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var HeadRowStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-weight: 400;\n  "], ["\n    font-weight: 400;\n  "])))
});
var TitleCellStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: block;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    text-transform: uppercase;\n    font-size: ", ";\n    font-weight: 400;\n    margin-left: -1px;\n    text-align: left;\n    padding: ", " 0 ", ";\n    border-bottom: 1px solid ", ";\n  "], ["\n    display: block;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    text-transform: uppercase;\n    font-size: ", ";\n    font-weight: 400;\n    margin-left: -1px;\n    text-align: left;\n    padding: ", " 0 ", ";\n    border-bottom: 1px solid ", ";\n  "])), theme_1.theme.FONT_SIZE(13), theme_1.theme.UNIT(3), theme_1.theme.UNIT(2), theme_1.theme.COLOR('line-mid'))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.table(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Head: styled_components_1.default.thead(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), HeadStyles),
  HeadRow: styled_components_1.default.tr(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), HeadRowStyles),
  TitleCell: styled_components_1.default.th(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), TitleCellStyles),
  Body: styled_components_1.default.tbody(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Row: styled_components_1.default.tr(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), RowStyles),
  HeaderCell: styled_components_1.default.th(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), HeaderCellStyles),
  Cell: styled_components_1.default.td(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), CellStyles)
};
var DataTable = function (props) {
  var className = props.className,
    isFullScreen = props.isFullScreen,
    values = props.values,
    title = props.title,
    cellSpacing = props.cellSpacing;
  return react_1.default.createElement(My.Container, {
    className: className,
    isFullScreen: isFullScreen,
    cellSpacing: cellSpacing
  }, react_1.default.createElement(My.Head, null, react_1.default.createElement(My.HeadRow, null, react_1.default.createElement(My.TitleCell, {
    dangerouslySetInnerHTML: {
      __html: title ? "".concat(title, ":") : '&nbsp;'
    }
  }))), react_1.default.createElement(My.Body, null, values.map(function (_a, i) {
    var name = _a.name,
      value = _a.value;
    return react_1.default.createElement(My.Row, {
      key: "table-".concat(i)
    }, react_1.default.createElement(My.HeaderCell, {
      dangerouslySetInnerHTML: {
        __html: name ? "".concat(name, ":") : '&nbsp;'
      }
    }), react_1.default.createElement(My.Cell, null, value));
  })));
};
exports.DataTable = DataTable;
exports.DataTable.defaultProps = exports.DataTableDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;